import { useEffect, useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

export function TasksPage() {
  const [tasks, setTasks] = useState<Array<{ id: number; title: string; status: string; priority: string; case_id: string | null }>>([]);
  const [title, setTitle] = useState('');

  const load = () => api.get<{ tasks: typeof tasks }>('/api/investigate/tasks?status=open').then((d) => setTasks(d.tasks));

  useEffect(() => {
    void load();
  }, []);

  const create = async (e: FormEvent) => {
    e.preventDefault();
    await api.post('/api/investigate/tasks', { title });
    setTitle('');
    await load();
  };

  const done = async (id: number) => {
    await api.patch(`/api/investigate/tasks/${id}`, { status: 'done' });
    await load();
  };

  return (
    <div>
      <h1>Werkvoorraad</h1>
      <p className="page-lead">Open taken over alle zaken — of maak een losse taak aan.</p>
      <form className="panel toolbar" onSubmit={(e) => void create(e)}>
        <div className="field" style={{ flex: 1 }}>
          <label>Taak</label>
          <input className="input" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </div>
        <button className="btn" type="submit">Toevoegen</button>
      </form>
      <div className="msg-list">
        {tasks.map((t) => (
          <article className="msg" key={t.id}>
            <div className="msg-head">
              <span>
                <strong>{t.title}</strong> · {t.priority}
                {t.case_id && (
                  <>
                    {' · '}
                    <Link to={`/cases/${t.case_id}`}>zaak</Link>
                  </>
                )}
              </span>
              <button className="btn btn-sm" type="button" onClick={() => void done(t.id)}>
                Klaar
              </button>
            </div>
          </article>
        ))}
        {tasks.length === 0 && <div className="empty">Geen open taken.</div>}
      </div>
    </div>
  );
}
